/**
 * Monitoring Request Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.monitoringRequestDetailFormatter = function(value, row) {
    let html = '';
    if (row.message) {
        html += '<div class="form-group">';
        html += "<label>"+__("Message:")+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.message+"</textarea>";
        html += "</div>";
    }
    return html;
};
